<template>
    <div class="cz3__product-preview">
        <renderer :new-version="true" />

        <div class="cz3__product-preview__shade"></div>

        <button
            class="cz3__help-button"
            :aria-label="$t('V3_HELP')"
            @click.prevent="help"
        >
            <!-- eslint-disable -->
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"><circle cx="18" cy="18" r="18" fill="#000" fill-opacity=".3"/><g clip-path="url(#a)"><path fill="#fff" d="M17.225 18.708c.642-1.158 1.875-1.841 2.592-2.866.758-1.075.333-3.084-1.817-3.084-1.408 0-2.1 1.067-2.392 1.95L13.45 13.8c.592-1.775 2.2-3.3 4.542-3.3 1.958 0 3.3.892 3.983 2.008.583.959.925 2.75.025 4.084-1 1.475-1.958 1.925-2.475 2.875-.208.383-.291.633-.291 1.866h-2.409c-.008-.65-.108-1.708.4-2.625Zm2.442 5.959c0 .916-.75 1.666-1.667 1.666-.916 0-1.666-.75-1.666-1.666 0-.917.75-1.667 1.666-1.667.917 0 1.667.75 1.667 1.667Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M8 8h20v20H8z"/></clipPath></defs></svg>
            <!-- eslint-enable -->
        </button>

        <button
            class="cz3__close-button cz3__hide-lg"
            :aria-label="$t('V3_RETURN')"
            @click.prevent="close"
        >
            <!-- eslint-disable -->
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"><circle cx="18" cy="18" r="18" fill="#000" fill-opacity=".3"/><mask id="a" width="20" height="20" x="8" y="8" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M8 8h20v20H8z"/></mask><g mask="url(#a)"><path fill="#fff" d="m13.333 23.833-1.167-1.166L16.834 18l-4.666-4.667 1.166-1.167L18 16.834l4.666-4.666 1.167 1.166L19.167 18l4.666 4.666-1.166 1.167L18 19.167l-4.667 4.666Z"/></g></svg>
            <!-- eslint-enable -->
        </button>

        <button
            class="cz3__close-button-logo cz3__hide-sm"
            :aria-label="$t('V3_RETURN')"
            @click.prevent="close"
        >
            <img src="../../assets/logo-pelican@2x.png" />
        </button>

        <popper
            v-if="toastMessage"
            ref="toast"
            trigger="clickToToggle"
            root-class="cz3__toast"
            transition="cz2__fade"
            :options="{
                placement: 'auto',
                modifiers: { offset: { offset: '0, 10px' } }
            }"
        >
            <div class="popper cz3__popper">
                <p v-if="toastMessage">
                    {{toastMessage}}
                </p>

                <p v-if="toastSubline">
                    {{toastSubline}}
                </p>

                <button
                    :aria-label="$t('V3_CLOSE')"
                    @click.prevent="closeToast"
                >
                    <!-- eslint-disable -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><mask id="close-a" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#close-a)"><path fill="#000" d="m5.334 15.833-1.167-1.166L8.834 10 4.167 5.333l1.167-1.166L10 8.833l4.667-4.666 1.167 1.166L11.167 10l4.667 4.667-1.167 1.166L10 11.167l-4.666 4.666Z"/></g></svg>
                    <!-- eslint-disable -->
                </button>
            </div>

            <button slot="reference" class="cz3__toast-trigger">
                <img src="../../assets/v2/icon-warning.svg" />
            </button>
        </popper>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__product-preview {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            background: #fff;

            .cz2__renderer {
                @include respond-below(sm) {
                    height: 100%;
                }
            }

            .swiper-wrapper {
                top: 0;
            }

            .swiper-pagination {
                @include respond-below(sm) {
                    position: absolute;

                    right: 10px;
                    bottom: 40px;
                }
            }
        }

        .cz3__product-preview__shade {
            position: absolute;

            left: 0;
            top: 0;

            width: 100%;
            height: 100%;

            z-index: 900;

            pointer-events: none;

            // background: rgba(0, 0, 0, 0.04);
        }

        .cz3__help-button {
            display: none;

            position: absolute;

            width: 36px;
            height: 36px;

            left: 16px;
            bottom: 16px;

            border: none;
            border-radius: 36px;

            background: none;

            z-index: 1000;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            @include respond-above(sm) {
                right: 16px;
                left: auto;
            }
        }

        .cz3__close-button {
            position: absolute;

            width: 36px;
            height: 36px;

            right: 16px;
            top: 16px;

            border: none;
            border-radius: 36px;

            background: none;

            z-index: 1000;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            @include respond-above(sm) {
                right: auto;
                left: 16px;
            }
        }

        .cz3__close-button-logo {
            position: absolute;

            width: 160px;
            height: 58px;

            right: 16px;
            top: 16px;

            border: none;
            border-radius: 36px;

            background: none;

            z-index: 1000;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            @include respond-above(sm) {
                right: auto;
                left: 16px;
            }
        }

        .cz3__toast-trigger {
            position: absolute;

            width: 36px;
            height: 36px;

            right: 16px;
            top: 84px;

            border: none;
            border-radius: 36px;

            background: none;

            z-index: 1000;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }
        }
    }
</style>

<script>
    import Popper from 'vue-popperjs';

    import Renderer from '../Renderer.vue';

    export default {
        components: {
            Renderer,
            Popper,
        },

        computed: {
            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            isEmbedded() {
                return this.selectedStep === 'review';
            },

            /**
             * Is design outside of bounds.
             */
            designOutside() {
                return this.$store.state.designOutside;
            },

            /**
             * Toast message.
             */
            toastMessage() {
                if (this.$store.state.toastMessage != null) {
                    return this.$store.state.toastMessage;
                }

                if (this.designOutside) {
                    return this.$t('DESIGN_OUTSIDE_WARNING');
                }

                return null;
            },

            toastSubline() {
                if (this.$store.state.toastMessage != null) {
                    return null;
                }

                if (this.designOutside) {
                    return this.$t('DESIGN_OUTSIDE_WARNING_SUBLINE');
                }

                return null;
            },

            /**
             * Toast message type.
             */
            toastMessageType() {
                if (this.$store.state.toastMessageType) {
                    return this.$store.state.toastMessageType;
                }

                if (this.designOutside) {
                    return 'error';
                }

                return null;
            },

            /**
             * Can toast message be dismissed.
             */
            canClearToast() {
                if (this.$store.state.toastMessage != null) {
                    return true;
                }

                return false;
            },
        },

        watch: {
            toastMessage() {
                if (this.$store.state.toastMessageType) {
                    clearTimeout(this.toastTimer);

                    this.toastTimer = setTimeout(() => {
                        this.$store.dispatch('toast', null);
                    }, 15000);
                }
            },
        },

        methods: {
            help() {
                this.$store.dispatch('showHelp', 'help');
            },

            close() {
                this.$store.dispatch('showExitConfirmation', true);
            },

            closeToast() {
                if (this.$refs.toast) {
                    this.$refs.toast.doClose();
                }
            },
        },
    };
</script>
